
import RichContent from '../util/rich/RichContent';

import {List,ActivityIndicator,Button,InputItem,Flex} from 'antd-mobile'

const server = window.server;

class Main extends React.Component {
	constructor(props) { 
		super(props);
	}
	render() {
		const {data,apps} = this.props;
		const {app} = data;
		if (!app) {
			return (
				<div className="csm-app-baseinfo-loading">
        			<ActivityIndicator animating size="large" style={{backgroundColor:'#000'}}/>
        		</div>
			)
		}
		return (
			<div>
			 	<List>
			 		<InputItem editable={false} value={ app ? app.s_number : "" } >应用编码</InputItem>
		      		<InputItem editable={false} value={ app ? app.s_name : "" }  >应用名称</InputItem>
		      		<InputItem editable={false} value={ app ? app.s_tradename : "" } >适用行业</InputItem>
		      		<InputItem editable={false} value={ app ? app.s_ec : "" } >EC兼容</InputItem>
		      		<InputItem editable={false} value={ app ? app.s_typename : "" } >所属模块</InputItem>
		      		<InputItem editable={false} value={ app ? app.s_database : "" } >数据库支持</InputItem>
		      		<InputItem editable={false} value={ app ? app.s_inter : "" } >浏览器兼容</InputItem>
		      		<InputItem editable={false} value={ app ? app.s_database : "" } >数据库支持</InputItem>
		      		{app.s_mobiurl!="" ? <Flex className='am-list-item am-input-item' >
		        		<Flex.Item className='am-input-label' style={{flex:'none'}}>在线体验</Flex.Item>
				        <Flex.Item className='am-input-control'>
				        	<Button type='ghost' size='small' inline onClick={()=>{sessionStorage.setItem('csmApps',JSON.stringify(apps));window.location.href= app.s_mobiurl}} style={{marginLeft:'0.15rem'}}>点击进入</Button>
				        </Flex.Item>
				    </Flex>  : ""}
				</List>
				<RichContent value={ app.s_desc }/>
				{
					app.imgfile && app.imgfile.map(el => {
						return <img src={server + el.url} />	
					})
				}
			</div>
		)
	}
}	

export default Main;


// WEBPACK FOOTER //
// ./project/components/app/Baseinfo.js